export class Maestro_Productos {
    id: number;
    descripcion: string;
    comercializacion: number;
    aliado: number;
    descripcionAliado: string;
    canal: number;
    descripcionCanal: string;
    tipoAfiliacion: number;
    habilitado: boolean;
    precio: number;
    compra: number;
    montobase: number;
    ivaimpuesto: number;
    ivabase: number;
    equivalencia: string;
    imagen: string;
    idReasignar: number;
    mesesReasignar: number;
    conservacion: boolean;
    sucursal_defecto: string;
    registrarBeneficiarios: boolean;
    beneficiariosrequeridos: boolean;
    terminoscondiciones: string;
    fechaInicioVigencia: Date;
    fechaFinVigencia: Date;
    notificacionSMS: boolean;
    notificacionEmail: boolean;
    registrarEstado: boolean;
    manejaFechaNacimiento: boolean;
    manejaDomicilio: boolean;
    manejaObservaciones: boolean;
    firmaElectronica: boolean;
    operacionesReembolso: boolean;
    programaSara: number;
    edadMinima: number;
    edadMaxima: number;
    tomador: boolean;
    duplicarTitular: boolean;
    urlNotificacion: string;
    lineaNacional: string;
    nroFijo: string;
    edadMinimaTomador: number;
    edadMaximaTomador: number;
    estadoDependienteFecha: boolean;
    permiteEditar: boolean;
    programacionPrecios: boolean;
    rutaRegistroFotografico: string;
    cantidadAnnosModelo: number;
    rutaControlOperaciones: string;
    rutaRegistroExpedientes: string;
}